module.exports = __webpack_public_path__ + "static/media/2015_conf_Creating_a_Hardware_Product_Startup.8ec32574.png";